module.exports = __webpack_public_path__ + "static/media/crueAvatar.e6be2695.png";